import isEmpty from 'lodash/isEmpty'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'

import Item from './Item'
import EmptyData from './../officer/EmptyData'

import useTranslate from '../../../i18n/useTranslate'

import { FacultyDataListType } from '../../../services/um/useSearchSettingFaculty'

interface Props {
    // order: Order
    // onSort: (value: Order) => void
    data: FacultyDataListType[]
}

const Result: React.FC<Props> = ({ data }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const history = useHistory()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    // const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    //     onSort(event.target.value)
    // }

    const GotoAddFaculty = () => {
        history.push('/setting-faculty/add')
    }

    return (
        <div className={classes.container}>
            <Grid container justify="space-between" alignItems="center" style={{ margin: '15px 0px' }}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h6">
                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${data.length}`])}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container justify="flex-end" spacing={2}>
                        <Grid item>
                            <Button
                                size="large"
                                variant="outlined"
                                color="primary"
                                onClick={GotoAddFaculty}
                                startIcon={<AddIcon />}
                            >
                                <Typography variant="button">{translate.get('UM.SETTING_FACULTY.ADD')}</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <EmptyData isEmpty={isEmpty(data)}>
                <Grid item xs={12}>
                    {data.map((item) => (
                        <Item
                            key={item.facultyID}
                            id={item.facultyID}
                            nameTH={item.facultyName.th}
                            nameEN={item.facultyName.en}
                            rec={item.rec.name[lang] ?? translate.get('LABEL.NOT_SPECIFIC')}
                        />
                    ))}
                </Grid>
            </EmptyData>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        margin: theme.spacing(2, 0),
    },
    typo: {
        fontWeight: 'bold',
    },
    sorting: {
        margin: theme.spacing(2, 0),
    },
}))

export default Result
